export default __webpack_public_path__ + "static/media/proposed.477ca85b.svg";